import Vue from "vue";
import VueRouter from "vue-router";
import Consult from "../views/consult/Consult.vue";
import Enroll from "../views/enroll/Enroll.vue";
import EnrollResult from "../views/enroll/Result.vue";

Vue.use(VueRouter);

const routes = [
  // {
  //   path: "*",
  //   redirect: {
  //     name: "consult",
  //     query: {
  //       institutionId: "MlcHngH1a8e07afcc934e128bb03c5df3bd5",
  //     },
  //   },
  // },
  {
    path: "/consult",
    name: "consult",
    component: Consult,
    meta: { title: "河北传媒学院在线咨询" },
  },
  {
    path: "/enroll",
    name: "enroll",
    component: Enroll,
    meta: { title: "河北传媒学院高考录取查询" },
  },
  {
    path: "/enrollResult",
    name: "enrollResult",
    component: EnrollResult,
    meta: { title: "河北传媒学院高考录取查询" },
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  next();
});

export default router;
